<template>
  <ProfileCard
    :title="$t('components.profile.view.security.title')"
    :subtitle="$t('components.profile.view.security.subtitle')"
  >
    <div class="flex max-md:flex-col gap-2">
      <ProfileEmail
        :user="user"
        :errors="errors"
        :saving="busy"
        class="w-full"
        @changeEmail="$emit('changeEmail', $event)"
        @resendEmail="$emit('resendEmail')"
        @clearErrors="$emit('clearErrors')"
      >
        <Button
          variant="secondary"
          type="grey"
          :size="maxSmall ? 'xl' : 'md'"
          class="mt-2 w-full"
        >
          {{ $t("components.profile.view.security.button.email") }}
        </Button>
      </ProfileEmail>
      <ProfilePassword
        :user="user"
        :errors="errors"
        :busy="busy"
        class="w-full"
        @changePassword="$emit('changePassword', $event)"
        @clearErrors="$emit('clearErrors')"
      >
        <Button
          variant="secondary"
          type="grey"
          :size="maxSmall ? 'xl' : 'md'"
          class="mt-2 w-full"
        >
          {{ $t("components.profile.view.security.button.password") }}
        </Button>
      </ProfilePassword>
      <ProfileLogout class="max-md:w-full" @logout="$emit('logout', $event)">
        <Tooltip
          :title="$t('components.profile.view.security.button.logout')"
          side="bottom"
        >
          <Button
            :label="
              maxSmall
                ? $t('components.profile.view.security.button.logout')
                : undefined
            "
            variant="secondary"
            type="grey"
            :size="maxSmall ? 'xl' : 'md'"
            :icon="!maxSmall"
            class="mt-2 max-md:w-full"
          >
            <template #start>
              <Icon name="logout" />
            </template>
          </Button>
        </Tooltip>
      </ProfileLogout>
    </div>
  </ProfileCard>
</template>

<script setup>
import { Button } from "@/SharedComponents/Buttons";
import { ProfileCard } from "@/SharedComponents/Profile/Partials";
import {
  ProfileEmail,
  ProfileLogout,
  ProfilePassword,
} from "@/SharedComponents/Profile/Dialogs";
import { useBreakpoints } from "@/Composables/useBreakpoints";
import { Icon } from "@/SharedComponents/Icon";
import { Tooltip } from "@/SharedComponents/Tooltips";

const { maxSmall } = useBreakpoints();

defineEmits([
  "changeEmail",
  "resendEmail",
  "changePassword",
  "logout",
  "clearErrors",
]);

defineProps({
  user: { type: Object, required: true },
  errors: { type: Object, default: () => ({}) },
  busy: { type: Boolean, required: false },
});
</script>
